import {AppStatus}       from './app-status';
import {VmcState}        from '../../shared-gen/Vending/Status/VmcState';
import { SelectionsFun } from "../../shared/model/selections/selections.fun";
import {MenuFun} from "../../shared/model/menus/menu.fun";

export class AppStatusFun {

	static getVmcState(_this: AppStatus): VmcState {
		return _this.deviceStatus.VendingStatus.VmcState;
	}

	/**
	 * Returns the number of currently available products of each product ID.
	 * May also be 0 if a HACCP condition disables a product.
	 */
	static getProductsRemainingCount(_this: AppStatus): {[productID: string]: number} {
		const ret: {[productID: string]: number} = {};

		// Cart full? Then no products are available any more
		const cart = _this.deviceStatus.VendingStatus.Cart;
		if (cart.Items.length >= _this.deviceStatus.UIConfig.CartItemsCount)
			return {};

		// Get remaining products in machine
		const selections = _this.selections;
		const fillLevels = _this.deviceStatus.MachineStatus.FillLevels;
		if (fillLevels) {
			for (const sel of fillLevels.Selections) {
				const productID = SelectionsFun.getProductID(selections, sel.SelectionNumber);
				if (productID != null)
					ret[productID] = sel.RemainingCount + (ret[productID] || 0);
			}
		}

		// Subtract products already in the shopping cart
		for (const item of cart.Items) {
			const productID = item.Product.ID;
			ret[productID] = Math.max(0, (ret[productID] || 0) - 1);
		}

		// If there is currently a HACCP error, disable cooled products
		try {
			if (_this.deviceStatus.MachineStatus.Problems.some(it => it.ID == "HACCP")) {
				const allProducts = MenuFun.getAllProducts(_this.menu);
				const cooledProducts = allProducts.filter(it => it.Cooled);
				cooledProducts.forEach(it => ret[it.ID] = 0);
			}
		} catch (ex) {
		}

		return ret;
	}

}
